import React, { FunctionComponent, ReactNode } from 'react';
import { ErrorBoundary } from '@minecraft.utils';
import { Container } from 'styles/Main.style';
import { useCheckRedirectToken } from 'utils/hooks/checkToken';

type Props = {
  children: ReactNode;
};

const AuthLayout: FunctionComponent<Props> = ({ children }) => {
  useCheckRedirectToken();

  return (
    <ErrorBoundary>
      <Container>{children}</Container>
    </ErrorBoundary>
  );
};

export default AuthLayout;
